  // export const ApiConnectionString = "https://localhost:7136"



export const ApiConnectionString = "https://therapydiaryapi-gncagmekhydkacgx.ukwest-01.azurewebsites.net"




